import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=ee5e8d6e&scoped=true&"
import script from "./page-not-found.vue?vue&type=script&lang=js&"
export * from "./page-not-found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5e8d6e",
  null
  
)

export default component.exports